<style lang="scss">
@import './base.scss';
</style>
<template>
  <div class="expr-relation">
    <div class="expr-relation-div"></div>
    <a :class="['item', selfRelation === '$and' ? 'selected' : '']" @click="choiceRelation('$and')">AND</a>
    <a :class="['item', selfRelation === '$or' ? 'selected' : '']" @click="choiceRelation('$or')">OR</a>
  </div>
</template>
<script>
  export default {
    props: {
      relation: {
        type: String,
        default() {
          return '$and';
        },
      },
    },
    data() {
      return {
        selfRelation: this.relation,
      };
    },
    methods: {
      choiceRelation(str) {
        this.selfRelation = str;
        this.$emit('on-choice-relation', str);
      },
    },
  };
</script>
